import dayjs from 'dayjs';

import request, { ContentType } from '../api-request';
import { CRLType } from 'shared/types/non-plan-year.types';
import { validateDate } from './validateDate';
import queryStringTag from './reportQueryStringTag';

export function downloadCurrentActiveReport(
  companyId: number,
  type: CRLType,
  startDate?: string,
  endDate?: string,
) {
  if (companyId <= 0) {
    return Promise.reject(new Error('Cannot download active during range report for invalid company.'));
  }

  try {
    const start = validateDate(
      'Cannot download active during range report for invalid start date.',
      startDate ?? dayjs().format(),
    );
    const end = validateDate(
      'Cannot download active during range report for invalid end date.',
      endDate ?? dayjs().format(),
    );

    const uri =
      queryStringTag`/api/companies/${companyId}/reports/current-active/${type}/export${start}${end}`;

    return request(uri, { method: 'GET', headers: { accept: ContentType.XLSX } });
  } catch (err) {
    return Promise.reject(err);
  }
}
